import TwoFactorAuthChangePage from "app/modules/auth/twofactorauthentication/TwoFactorAuthChangePage";
import { useState } from "react";
import { TwoFactorAuthenticationTypes } from "global/enums";
import { getTwoFactorAuthString } from "app/modules/auth/twofactorauthentication/TwoFactorAuthHelpers";
import { useSelector } from "react-redux";
import { getClientPortalUserProfile, selectUserProfile } from "./UserProfileSlice";
import { useThunkDispatch } from "setup/redux/thunkDispatch";
import SimpleModal from "cpl-react-common/components/Modals/SimpleModal";

const TwoFactorAuthDetails: React.FC = () => {
  const thunkDispatch = useThunkDispatch();
  const [showTwoFactorAuthModal, setShowChangeTwoFactorModal] = useState(false);
  const user = useSelector(selectUserProfile);

  return (
    <>
      <SimpleModal
        modalTitle="Two Factor Authentication"
        showModal={showTwoFactorAuthModal}
        dismissModalCallback={() => {
          setShowChangeTwoFactorModal(false);
        }}
      >
        <div className="row mb-6">
          <TwoFactorAuthChangePage
            currentAuthenticatorType={user.twoFactorAuthTypeID!}
            onSuccess={() => {
              setShowChangeTwoFactorModal(false);
              thunkDispatch(getClientPortalUserProfile());
            }}
          />
        </div>
      </SimpleModal>

      <div className="row">
        <div className="row align-items-end mb-6">
          <div className="col-12 col-md-6">
            <label htmlFor="twoFactorAuthType" className="form-label required">
              Two Factor Authentication Type
            </label>
            <input
              data-test-id="two-factor-auth-details__type-input"
              id="twoFactorAuthType"
              readOnly
              className="form-control form-control-plaintext"
              value={getTwoFactorAuthString(user.twoFactorAuthTypeID as TwoFactorAuthenticationTypes) ?? ""}
            />
          </div>
          <div className="col-12 col-md-6">
            <button
              data-test-id="two-factor-auth-details__change-type-button"
              className="cpl-btn cpl-btn-primary"
              type="button"
              onClick={() => setShowChangeTwoFactorModal(true)}
            >
              Change 2FA Type
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default TwoFactorAuthDetails;
